import * as React from 'react';
import { IChangeEventHandler } from '../../_types/nav';
import TextField from '@material-ui/core/TextField';

import { ISelectorDefault, search_param } from '../../_types/search';

interface Props {
    onChange: IChangeEventHandler<search_param>;
    searchParam: search_param;
    selector_cn: string;
    disabled?: boolean;
};

export const WholeNumberDefaults = 
    (selector_cn: string): ISelectorDefault => {
        return {
            comparison: "equals",
            values: ["0"]
        };
    };


const WholeNumberSelector: React.FC<Props> = (prop: Props) => {

    //const userState: IUserState = useContext(AuthContext);
    //const [exact, setexact] = useState<boolean>(false);

    const _value = ():string => {
        let  toReturn: string = '';
        if (prop.searchParam.values != null && prop.searchParam.values.length > 0) {
            toReturn = prop.searchParam.values[0]
            if (toReturn == null) { toReturn = '0'; }
        }
        return toReturn;
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const onlyNums = event.target.value.replace(/[^0-9]/g, '');

        

        if (onlyNums.length > 0 && onlyNums.length < 10) {
            let p = { ...prop.searchParam };
            p.values = [ parseInt(onlyNums).toString() ];
            p.comparison = "equals";
            prop.onChange(p);  
        } 
    }

return (
    <TextField disabled={prop.disabled} label="Query" value={_value()} onChange={handleChange}/>
)
}

export default WholeNumberSelector;